/**
 * PillsContainer Component
 *
 * Container for filter pills, shown when filters are collapsed and there are active filters.
 * Uses CSS grid animation (0fr/1fr) for smooth expand/collapse transitions.
 */

import { memo } from 'react';
import type { PillsContainerProps } from '../SearchAndFilters.types';
import { useSearchAndFiltersContext } from '../hooks/useSearchAndFiltersContext';
import styles from '../SearchAndFilters.module.css';

export const PillsContainer = memo(function PillsContainer({
  show,
  children,
}: PillsContainerProps) {
  const { variant } = useSearchAndFiltersContext();

  const baseClassName =
    variant === 'compact'
      ? `${styles.pillsContainer} ${styles.compact}`
      : styles.pillsContainer;
  const className = show ? `${baseClassName} ${styles.visible}` : baseClassName;

  return (
    <div className={className}>
      <div className={styles.pillsContainerInner}>{children}</div>
    </div>
  );
});
